/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateAuthorizedDto
 */
export interface CreateUpdateAuthorizedDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateAuthorizedDto
     */
    systemNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateAuthorizedDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAuthorizedDto
     */
    maxAmount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAuthorizedDto
     */
    employeeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAuthorizedDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAuthorizedDto
     */
    teamId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateAuthorizedDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateAuthorizedDto interface.
 */
export function instanceOfCreateUpdateAuthorizedDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "maxAmount" in value;
    isInstance = isInstance && "employeeId" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateAuthorizedDtoFromJSON(json: any): CreateUpdateAuthorizedDto {
    return CreateUpdateAuthorizedDtoFromJSONTyped(json, false);
}

export function CreateUpdateAuthorizedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateAuthorizedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'systemNumber': json['systemNumber'],
        'endDate': (new Date(json['endDate'])),
        'maxAmount': json['maxAmount'],
        'employeeId': json['employeeId'],
        'companyId': json['companyId'],
        'teamId': !exists(json, 'teamId') ? undefined : json['teamId'],
        'active': json['active'],
    };
}

export function CreateUpdateAuthorizedDtoToJSON(value?: CreateUpdateAuthorizedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'systemNumber': value.systemNumber,
        'endDate': (value.endDate.toISOString()),
        'maxAmount': value.maxAmount,
        'employeeId': value.employeeId,
        'companyId': value.companyId,
        'teamId': value.teamId,
        'active': value.active,
    };
}

